import { render, staticRenderFns } from "./Dash-audience-one.vue?vue&type=template&id=30dafab4"
import script from "./Dash-audience-one.vue?vue&type=script&lang=js"
export * from "./Dash-audience-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports